import styled from "@emotion/styled";
import React from "react";
import { Heading } from "../Heading";

const Wrapper = styled.button`
  all: unset;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  min-height: 200px;
  background-color: transparent;
  border: 2px dashed ${(props) => props.theme.colors.cloudDark};
  border-radius: 15px;
  text-align: center;
  box-sizing: border-box;

  &:focus-visible {
    outline: ${(props) => `2px solid ${props.theme.colors.forest}`};
  }

  &:hover {
    opacity: 80%;
  }
`;

type UnsureWhatToFundCardProps = {
  onClick: () => void;
};

export const UnsureWhatToFundCard = ({
  onClick,
}: UnsureWhatToFundCardProps) => {
  return (
    <Wrapper onClick={onClick} data-testid="unsure-what-to-fund-card">
      <Heading size={5} as="h3">
        Unsure what to fund?
      </Heading>
    </Wrapper>
  );
};
